// extracted by mini-css-extract-plugin
export default {"wrapper":"CheckBox_wrapper__LToSZ","element":"CheckBox_element__VDDQR"};